import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

// Versión actual de la app - ACTUALIZAR con cada release
export const APP_VERSION = '1.0.1';

// Comparar versiones (retorna: -1 si v1 < v2, 0 si igual, 1 si v1 > v2)
const compareVersions = (v1, v2) => {
  const parts1 = v1.split('.').map(Number);
  const parts2 = v2.split('.').map(Number);

  for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
    const num1 = parts1[i] || 0;
    const num2 = parts2[i] || 0;

    if (num1 < num2) return -1;
    if (num1 > num2) return 1;
  }

  return 0;
};

export const checkAppVersion = async () => {
  try {
    const configRef = doc(db, 'appConfig', 'version');
    const configSnap = await getDoc(configRef);

    if (!configSnap.exists()) {
      // Si no existe configuración, permitir uso normal
      return {
        needsUpdate: false,
        currentVersion: APP_VERSION,
        minVersion: null
      };
    }

    const config = configSnap.data();
    const minVersion = config.minVersion || '1.0.0';
    const forceUpdate = config.forceUpdate !== false; // Por defecto true

    const needsUpdate = forceUpdate && compareVersions(APP_VERSION, minVersion) < 0;

    return {
      needsUpdate,
      currentVersion: APP_VERSION,
      minVersion,
      updateMessage: config.updateMessage || 'Hay una nueva versión disponible. Por favor actualiza la aplicación para continuar.',
      storeUrl: config.storeUrl || 'https://play.google.com/store/apps/details?id=com.nomofarma.app'
    };
  } catch (error) {
    console.error('Error checking app version:', error);
    // En caso de error, permitir uso normal
    return {
      needsUpdate: false,
      currentVersion: APP_VERSION,
      minVersion: null,
      error: error.message
    };
  }
};
